module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-recaptcha",
    attrs: {
      "data-sitekey": _vm.siteKey
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-101cf5bb!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/Captcha.vue
// module id = 408
// module chunks = 0